/**
 * The delay in milliseconds before setting focus to an element.
 * Helps ensure focus is not stolen by popover rendering.
 */
export const FOCUS_DELAY = 150;
